<template>
  <div
    class="bg-surface-default-mid flex flex-col overflow-auto pb-[140px] lg:flex-row lg:overflow-y-hidden lg:pb-0"
  >
    <div class="relative grow px-24 pt-0 md:pt-48 lg:overflow-y-scroll">
      <div class="mx-auto mb-24 w-full grow md:mb-48 md:max-w-[820px]">
        <div class="flex flex-col gap-24 md:gap-48">
          <slot name="header" />
          <slot />
        </div>
      </div>
    </div>

    <div
      v-if="slots.aside"
      class="flex justify-center px-24 pt-40 lg:bg-surface-default-hi md:pt-48 lg:w-[27.5rem] lg:overflow-auto"
    >
      <slot name="aside" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { VNode } from 'vue'

const slots = defineSlots<{
  header?(): VNode
  default(): VNode
  aside?(): VNode
}>()
</script>
